module.exports = __webpack_public_path__ + "static/img/toOutside.4788b6d9.png";